module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#photo",
      toString: function () {
        return this.url;
      }
    }